(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vaulted-footer"] && !Shopify.designMode) return;
  try {
    
(function(){var picker=document.getElementById('VltCountryPicker');if(!picker)return;var trigger=picker.querySelector('.vlt-country-trigger'),form=document.getElementById('VltFooterLocalization'),hidden=document.getElementById('VltCountryCode');trigger.addEventListener('click',function(e){e.stopPropagation();var open=picker.classList.toggle('is-open');trigger.setAttribute('aria-expanded',open?'true':'false');trigger.querySelector('.vlt-country-arrow').style.transform=open?'rotate(225deg) translateY(2px)':'rotate(45deg) translateY(2px)'});picker.querySelectorAll('.vlt-country-option').forEach(function(o){o.addEventListener('click',function(){hidden.value=o.dataset.country;form.submit()})});document.addEventListener('click',function(e){if(!picker.contains(e.target)){picker.classList.remove('is-open');trigger.setAttribute('aria-expanded','false');trigger.querySelector('.vlt-country-arrow').style.transform='rotate(45deg) translateY(2px)'}})})();

  } catch(e) { console.error(e); }
})();
})();
